import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve media URLs that come back as relative /api/media/xxx
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BASE}${url}`;
  return url;
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
